import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '~/constants';
import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { integrationModel } from '~/models';
export const useRedirectWhenAccountingUnavailable = (accounting)=>{
    const navigate = useNavigate();
    const { refresh: refreshIntegrations } = useIntegrations({
        enabled: false
    });
    const [isRefreshingIntegrations, setIsRefreshingIntegrations] = useState(false);
    useEffect(()=>{
        setIsRefreshingIntegrations(true);
        refreshIntegrations({
            throwOnError: false
        }).then((param)=>{
            let { data: integrations } = param;
            if (integrations == null) return;
            const integration = integrationModel.accountingIntegration(integrations, accounting);
            const isLinkedAndNotReady = integration && integration.isLinked() && !integration.isReady();
            if (!integration || isLinkedAndNotReady) navigate(routes.availableApps);
        }).finally(()=>setIsRefreshingIntegrations(false));
    }, [
        accounting
    ]);
    return {
        isRefreshingIntegrations
    };
};
